/*
 * MENGLLE PDP gallery A+B helpers
 * On variant change, activate the variant featured media in slideshow/thumbs.
 */
(function () {
  function mediaIdFromVariant(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    return null;
  }

  function selectMediaInProduct(container, mediaId) {
    if (!container || !mediaId) return;
    var root = container.closest("[data-section-type=\"product\"]") || container;
    var thumb = root.querySelector("[data-slideshow-thumbnail][data-media-select=\"" + mediaId + "\"]");
    if (thumb) {
      thumb.click();
      return;
    }
    var slide = root.querySelector("[data-media-slide][data-media-id=\"" + mediaId + "\"]");
    if (slide) {
      slide.scrollIntoView({ behavior: "smooth", block: "nearest" });
      root.querySelectorAll("[data-slideshow-thumbnail]").forEach(function (el) {
        el.classList.toggle("is-activated", el.getAttribute("data-media-select") === mediaId);
      });
    }
  }

  document.addEventListener("theme:variant:change", function (event) {
    var variant = event.detail && event.detail.variant;
    var mediaId = mediaIdFromVariant(variant);
    if (!mediaId) return;
    selectMediaInProduct(event.target, mediaId);
  });
})();
